<template>
  <v-app app id="inspire" v-resize="resizeGrid">
    <TopAppBar></TopAppBar>
    <v-navigation-drawer
      app
      v-model="$store.getters.drawerToggle"
      :clipped="$vuetify.breakpoint.lgAndUp"
      width="210px"
    >
      <LeftNavigationDrawer></LeftNavigationDrawer>
    </v-navigation-drawer>
    <v-navigation-drawer
      app
      v-if="!$store.getters.drawerToggle"
      class=""
      :mini-variant="!$store.getters.drawerToggle"
      color="white"
      mini-variant-width="60"
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <LeftNavigationDrawerSmall></LeftNavigationDrawerSmall>
    </v-navigation-drawer>
    <v-content :key="$route.fullPath">
      <v-card class="text-blue top-breadcrumbs">
        <v-breadcrumbs :items="crumbs" divider=">" class="pa-2">
        </v-breadcrumbs>
      </v-card>
      <v-container fluid class="pa-0 ma-0">
       <section class="app-main" style="min-height:100%">
        <transition name="fade-transform">
          <router-view />
        </transition>
      </section>
      </v-container>
    </v-content>
    <globalSearch v-if="searchDialog" :searchDialog="searchDialog"/>
    <loader
      v-if="$store.getters.showLoader"
      v-bind:data="$store.getters.loaderMessage"
    ></loader>
    <snak-bar
      v-if="$store.getters.showAlert"
      v-bind:status="$store.getters.showAlert"
      v-bind:message="$store.getters.alertMessage"
      v-bind:color="$store.getters.alertColor"
    >
    </snak-bar>
  </v-app>
</template>
<script>
import {systemSetting} from '../routers/index.js'
import TopAppBar from '@/View/components/topAppBar.vue'
import snakBar from '@/View/components/SnakBar.vue'
import Loader from '@/View/components/Loader.vue'
import LeftNavigationDrawer from '@/View/components/leftNavigationDrawer.vue'
import LeftNavigationDrawerSmall from '@/View/components/leftNavigationDrawerSmall.vue'
export default {
  components: {
    TopAppBar,
    LeftNavigationDrawer,
    LeftNavigationDrawerSmall,
    snakBar,
    Loader
  },
  data () {
    return {
      searchDialog: false,
      cardView: false,
      menu: false
    }
  },
  computed: {
    crumbs: function () {
      let pathArray = this.$route.path.split('/')
      pathArray.splice(2, 0)
      let parentRouter = [
        {
          text: 'Call Center',
          to: '/dashboard',
          disabled: false
        },
        {
          text: 'System Settings',
          to: '/systemSetting/dashboard',
          disabled: false
        }
      ]

      for (let i = 1; i < pathArray.length; i++) {
        for (let b = 0; b < systemSetting.children.length; b++) {
          let obj = {
            text: '',
            to: '',
            disabled: false
          }
          if (systemSetting.children[b].meta.breadCrumb.toLowerCase() === pathArray[i] && pathArray[i] !== 'dashboard') {
            obj.text = systemSetting.children[b].meta.title
            obj.to = systemSetting.children[b].redirect
            obj.disabled = systemSetting.children[b].redirect === this.$route.path
            console.log('pathArray[i]', obj)
            parentRouter.push(obj)
            break
          }
        }
      }
      console.log('parentRouter', this.$route)
      parentRouter.push({
        text: this.$route.meta.title,
        disabled: true,
        to: ''
      })
      console.log('parentRouter', JSON.stringify(parentRouter))
      return parentRouter
    }
  },
  mounted () {
    this.$root.$on('closeDialog', (response) => {
      this.searchDialog = false
    })
  },
  methods: {
    resizeGrid () {
      this.innerHeight = window.innerHeight
      if (window.innerWidth < 1264) {
        this.cardView = true
      } else {
        this.cardView = false
      }
    }
  }
}
</script>
<style scoped>
.v-list--dense .v-list-item .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list-item--dense .v-list-item__title {
  font-size: 0.9125rem !important;
  font-weight: 500 !important;
  line-height: 1rem;
}
.barsearch {
  width: 350px;
  opacity: 0.5;
}
.filter-green {
   filter: invert(48%) sepia(79%) saturate(906%) hue-rotate(80deg) brightness(50%) contrast(20%) grayscale(200%);
}
.mobileSearch {
  width: 300px;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/View/systemSetting/layOut/Layout.vue